import { RootState } from '../store'

export const authSelector = (state: RootState) => {
  const { auth } = state

  return auth
}
